import { AnyAction, Dispatch, createSelector } from '@reduxjs/toolkit'
import { sliderSlice, buildSliderProperty } from 'Slices/sliderSlice'
import type { RootState } from 'Utils/store'
import ExperienceConfig from 'Configs/fields/years_of_work_experience.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

export const ExperienceSlice = sliderSlice(
  ExperienceConfig.column,
  'setOnDemandExperienceRange',
  [ExperienceConfig.range.min, ExperienceConfig.range.max],
  ExperienceConfig.meta,
  ExperienceConfig.defaultValues
)

export const selectExperience = createSelector(
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.experience['selectedMin'],
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.experience['selectedMax'],
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.experience['selections'],
  (
    selectedMinExperience: number,
    selectedMaxExperience: number,
    selections: string[]
  ): {
    step: number
    ariaLabel: string
    selectedMinExperience: number
    selectedMaxExperience: number
    minExperience: number
    maxExperience: number
    values: string[]
    filterQuery: any
    audienceTypes: string[]
    label: string
    selections: string[]
  } => {
    return {
      selectedMinExperience,
      selectedMaxExperience,
      minExperience: ExperienceConfig.range.min,
      maxExperience: ExperienceConfig.range.max,
      step: ExperienceConfig.range.step,
      ariaLabel: ExperienceConfig.ARIA_LABEL,
      values: ExperienceConfig.values,
      filterQuery: buildSliderProperty(
        ExperienceConfig.column,
        [selectedMinExperience, selectedMaxExperience],
        ExperienceConfig.meta
      ),
      audienceTypes: ExperienceConfig.source[contractSource].audience_types,
      label: ExperienceConfig.meta.label,
      selections,
    }
  }
)

export const { setOnDemandExperienceRange, setOnDemandExperienceRangeSelection } = ExperienceSlice.actions

export const setExperienceDefaultValue = (
  dispatch: Dispatch<AnyAction>,
  audienceType: string
) => {
  const experienceConfig = ExperienceConfig.source[contractSource]
  const audienceTypes = experienceConfig.audience_types

  if (!audienceType) return

  if (audienceTypes.includes(audienceType)) {
    dispatch(
      setOnDemandExperienceRangeSelection({selections: [
        ExperienceConfig.range.min,
        ExperienceConfig.range.max
      ]})
    )
  }
}

export default ExperienceSlice.reducer
